export const environment = {
    apiURL: "https://test.medexam.app/backend/api/v1",
    production: true
};